import { post } from "@/request/http";
import { baseURL } from "../public/base";

// 获取实验列表
export { getExpList } from "../public/exp";

// 获取学校列表
export { getSchoolList } from "../public/school";

// 获取所有分类列表
export const getVirtualCategoryList = p =>
    post("/exp/getVirtualCategoryList", p);

// 上传图片
export const uploadsFile = baseURL + "/exp/uploadsFile";

export const updateVirtualSimulation = p =>
    post("/exp/updateVirtualSimulation", p);
